import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'catalogos',
        title: 'Catálogos',
        translate: 'NAV.CATALOGOS',
        type: 'collapsable',
        icon: 'folder_open',
        children: [
            {
                id: 'Ramos',
                title: 'Ramos',
                translate: 'NAV.ADMINISTRACION_RAMOS.TITLE',
                type: 'item',
                icon: 'directions_car',
                url: '/ramos/administracion'
            },
            {
                id: 'Agentes/Subagentes',
                title: 'Agentes',
                translate: 'NAV.ADMINISTRACION_AGENTES.TITLE',
                type: 'item',
                icon: 'perm_identity',
                url: '/agentes/administracion'
            },
            {
                id: 'Companias',
                title: 'Compañías',
                translate: 'NAV.ADMINISTRACION_COMPANIAS.TITLE',
                type: 'item',
                icon: 'location_city',
                url: '/companias/administracion'
            },
            {
                id: 'Productos',
                title: 'Productos',
                translate: 'NAV.ADMINISTRACION_COBERTURAS.TITLE',
                type: 'item',
                icon: 'library_add',
                url: '/coberturas/administracion'
            },
            {
                id: 'Clientes',
                title: 'Clientes',
                translate: 'NAV.ADMINISTRACION_CLIENTES.TITLE',
                type: 'item',
                icon: 'contacts',
                url: '/clientes/administracion'
            },
            {
                id: 'Sucursales',
                title: 'Sucursales',
                translate: 'NAV.ADMINISTRACION_SUCURSALES.TITLE',
                type: 'item',
                icon: 'store',
                url: '/sucursales/administracion'
            },
            {
                id: 'Grupos',
                title: 'Grupos',
                translate: 'NAV.ADMINISTRACION_GRUPOS.TITLE',
                type: 'item',
                icon: 'group',
                url: '/grupos/administracion'
            }
        ]
    },
    {
        id: 'Utilidades',
        title: 'Utilidades',
        translate: 'Utilidades',
        type: 'collapsable',
        icon: 'build',
        children: [
            {
                id: 'Tipos de cambio',
                title: 'Tipo de Cambio',
                translate: 'NAV.ADMINISTRACION_TIPOCAMBIO.TITLE',
                type: 'item',
                icon: 'attach_money',
                url: '/tipocambio/administracion'
            },
            {
                id: 'Usuarios',
                title: 'Usuarios',
                translate: 'NAV.ADMINISTRACION_USUARIOS.TITLE',
                type: 'item',
                icon: 'supervised_user_circle',
                url: '/usuarios/administracion'
            }
        ]
    },
    {
        id: 'Interfaces',
        title: 'Interfaces',
        translate: 'Interfaces',
        type: 'collapsable',
        icon: 'device_hub',
        children: [
            {
                id: 'Polizas',
                title: 'Carga de Pólizas y Endosos',
                translate: 'NAV.INTERFACES_POLIZAS.TITLE',
                type: 'item',
                icon: 'transform',
                url: '/interfaces/polizas'
            },
            {
                id: 'Cobranzas',
                title: 'Carga de Cobranzas',
                translate: 'NAV.INTERFACES_COBRANZAS.TITLE',
                type: 'item',
                icon: 'transform',
                url: '/interfaces/cobranzas'
            },
            // {
            //     id: 'Endosos',
            //     title: 'Carga de Endosos',
            //     translate: 'NAV.INTERFACES_ENDOSOS.TITLE',
            //     type: 'item',
            //     icon: 'transform',
            //     url: '/interfaces/endosos'
            // }
        ]
    },
    {
        id: 'Captura',
        title: 'Captura',
        translate: 'Captura',
        type: 'collapsable',
        icon: 'blur_linear',
        children: [
            {
                id: 'Ordenes',
                title: 'Ordenes de Trabajo',
                translate: 'NAV.ADMINISTRACION_ORDENES_TRABAJO.TITLE',
                type: 'item',
                icon: 'assignment',
                url: '/captura/ordenes'
            },
            {
                id: 'Polizas',
                title: 'Captura de Polizas',
                translate: 'NAV.ADMINISTRACION_CAPTURA_POLIZA.TITLE',
                type: 'item',
                icon: 'border_outer',
                url: '/captura/poliza'
            },
            {
                id: 'Cobranzas',
                title: 'Captura de Cobranzas',
                translate: 'NAV.ADMINISTRACION_CAPTURA_COBRANZA.TITLE',
                type: 'item',
                icon: 'money',
                url: '/captura/cobranza'
            },
            {
                id: 'Endosos',
                title: 'Captura de Endosos',
                translate: 'NAV.ADMINISTRACION_CAPTURA_ENDOSOS.TITLE',
                type: 'item',
                icon: 'money',
                url: '/captura/endosos'
            },
            {
                id: 'Siniestros',
                title: 'Captura de Siniestros',
                translate: 'NAV.ADMINISTRACION_CAPTURA_SINIESTROS.TITLE',
                type: 'item',
                icon: 'money',
                url: '/captura/siniestros'
            }
        ]
    },
    {
        id: 'Consultas',
        title: 'Consultas',
        translate: 'Consultas',
        type: 'collapsable',
        icon: 'search',
        children: [
            {
                id: 'ConsultaPolizas',
                title: 'Consulta de Polizas',
                translate: 'NAV.ADMINISTRACION_CONSULTA_POLIZA.TITLE',
                type: 'item',
                icon: 'assignment',
                url: '/consulta/poliza'
            }

        ]
    },
    {
        id: 'Reportes',
        title: 'Reportes',
        translate: 'Reportes',
        type: 'collapsable',
        icon: 'assessment',
        children: [
            {
                id: 'ControlCartera',
                title: 'Control de Cartera',
                translate: 'ControlCartera',
                type: 'collapsable',
                icon: 'search',
                children: [
                    {
                        id: 'PolizasPagadas',
                        title: 'Polizas Pagadas',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_POLIZASPAGADAS.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/poliza-pagada'
                    },
                    {
                        id: 'PolizasPorCobrar',
                        title: 'Polizas Por Cobrar',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_POLIZASPORCOBRAR.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/poliza-cobrar'
                    },
                    {
                        id: 'PolizasPorRenovar',
                        title: 'Polizas Por Renovar',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_POLIZASPORRENOVAR.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/poliza-por-renovar'
                    },
                    {
                        id: 'PolizasRenovadas',
                        title: 'Polizas Renovada',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_POLIZASRENOVADAS.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/poliza-renovada'
                    },
                    {
                        id: 'PolizasEnDeposito',
                        title: 'Polizas En Deposito',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_POLIZASENDEPOSITO.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/poliza-en-deposito'
                    },
                    {
                        id: 'Produccion',
                        title: 'Producción',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_PRODUCCION.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/produccion'
                    },
                    {
                        id: 'EstadoDeCliente',
                        title: 'Estado de Cliente',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_ESTADODECLIENTE.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/estado-de-cliente'
                    },
                    {
                        id: 'Comisiones',
                        title: 'Comisiones',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_COMISIONES.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/comisiones'
                    }
                    ,
                    {
                        id: 'Recordatorios',
                        title: 'Recordatorios',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_RECORDATORIOS.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/recordatorios'
                    },
                    {
                        id: 'Solicitudes',
                        title: 'Solicitudes',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_SOLICITUDES.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/solicitudes'
                    },
                    {
                        id: 'GeneralPolizas',
                        title: 'General Polizas',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_GENERALPOLIZAS.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/general-polizas'
                    },
                    {
                        id: 'Clientes',
                        title: 'Clientes',
                        translate: 'NAV.REPORTES_CONTROLCARTERA_CLIENTES.TITLE',
                        type: 'item',
                        icon: 'assignment',
                        url: '/reportes/clientes'
                    },
                ]

            }

        ]
    }
];
